<div class="container ktbl-container-border ktbl-container-size">
  <h3 mat-dialog-title>Hinweis: Summe der Windhäufigkeit</h3>

  <mat-dialog-content>
    <mat-label>Die Summe der Windhäufigkeit beträgt {{ windhaeufigkeitSumme }} ‰</mat-label>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="ktbl-button-container">
      <div class="ktbl-button-container-left">
        <button class="ktbl-button-sekundaer ktbl-button-width-m" type="button"
          [mat-dialog-close]="0">
          Zurück
        </button>
      </div>


      <div class="ktbl-button-container-right">
        <button class="ktbl-button-primaer ktbl-button-width-m ktbl-button-width-m-c" type="button" [mat-dialog-close]="2">
          Winddaten bearbeiten
        </button>

        <button class="ktbl-button-primaer ktbl-button-width-m" type="button" [mat-dialog-close]="1">
          Zum Ergebnis
          <i class="fas fa-arrow-right ktbl-icon-vertical-align"></i>
        </button>
      </div>
    </div>

  </mat-dialog-actions>
  <div class="ktbl-spacer-top-bottom"></div>
</div>